import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles<any>(theme =>
  createStyles({
    input: {
      width: '100%',
      borderRadius: '8px',
      backgroundColor: (props: any) => (props?.isSearchBar ? STYLE.COLOR.WHITE : STYLE.COLOR.INPUT_BACKGROUND),
      borderColor: STYLE.COLOR.INPUT_BORDER,
      borderWidth: '1px',
      color: `${STYLE.COLOR.TEXT1} !important`,
      '& .MuiInputLabel-root': {
        fontWeight: '400',
        fontSize: `14px`,
        lineHeight: '20px',
        color: STYLE.COLOR.TEXT3,
        marginBottom: '0px',
        '&:not(.MuiInputLabel-shrink)': {
          top: '50%',
          transform: 'translateY(-50%)',
          left: '20px',
          transition: 'all 0.2s ease-in',
        },
      },
      '& fieldset': {
        borderRadius: '8px',
        borderColor: props => (props?.isSearchBar ? STYLE.COLOR.STROKE_DEFAULT : STYLE.COLOR.INPUT_BORDER),
        '& legend': {
          width: '0px !important',
        },
      },
      '& .MuiOutlinedInput-root.Mui-error': {
        backgroundColor: `${STYLE.COLOR.ERROR_LIGHTER} !important`,
      },
      '& :hover': {
        '&:not(.Mui-error):not(.Mui-disabled)': {
          '& fieldset': {
            borderColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
          },
        },
      },
      '& .Mui-disabled': {
        opacity: 0.5,
        cursor: 'not-allowed !important',
        '& fieldset': {
          borderColor: `${STYLE.COLOR.INPUT_BORDER} !important`,
        },
        '& .MuiInputBase-input': {
          color: `${STYLE.COLOR.TEXT1} !important`,
        },
        '& .MuiInputLabel-root': {
          color: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: STYLE.COLOR.TEXT2,
        backgroundColor: STYLE.COLOR.WHITE,
        borderRadius: '12px',
        padding: '4px 6px 4px 6px',
        fontWeight: '500',
        fontSize: `10px`,
        lineHeight: '16px',
        opacity: '1 !important',
        left: 16,
        transform: 'translateY(-12px)',
        transition: 'all 0.2s ease-in',
      },
      '& .MuiOutlinedInput-root': {
        paddingTop: '14px !important',
        paddingRight: '20px !important',
        paddingBottom: '14px !important',
        paddingLeft: '20px !important',
      },
    },
    multilineInput: {
      '& .MuiInputBase-root': {
        padding: 0,
        height: 'auto',
        minHeight: '100px',
      },
      '& .MuiInputBase-input': {
        height: 'auto !important',
        minHeight: '80px !important',
        padding: '14px 20px !important',

        '&::placeholder': {
          textTransform: 'none',
        },
      },
      '& .MuiInputLabel-root': {
        '&:not(.MuiInputLabel-shrink)': {
          top: '14px',
          left: '20px',
          transform: 'translateY(0)',
        },
        '&.MuiInputLabel-shrink': {
          top: '-6px',
          left: '16px',
          transform: 'translateY(0)',
        },
      },
      '& .MuiInputLabel-outlined': {
        '&:not(.MuiInputLabel-shrink)': {
          top: '14px',
          left: '20px',
          transform: 'translateY(0)',
        },
        '&.MuiInputLabel-shrink': {
          top: '-6px',
          left: '16px',
          transform: 'translateY(0)',
          backgroundColor: 'white',
          padding: '0 4px',
        },
      },
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    skippableMark: {
      color: STYLE.COLOR.WARNING,
      paddingLeft: '3px',
    },
  }),
);
